import { createContext } from 'react';

const SelectionContext = createContext({
    /** @type {import('@mui/x-data-grid').GridRowId[]} */
    selectionModel: [],
    /** @type {import('@mui/x-data-grid').DataGridProps['onSelectionModelChange']} */
    onSelectionModelChange() {
        throw new Error('No DataGridDyl.SelectionContext in tree.');
    },
});

export default SelectionContext;